import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Form from '../components/form';

import React from 'react'
import HeroImg2 from '../components/HeroImg2';


const Contact = () => {
  return (
     <>
     <Navbar/>
     <HeroImg2 heading="CONTACT." text="Lets Have a chat"/>
     <Form/>
    
   <Footer />
      
    </>
  )
}

export default Contact;
